export const sequences2030 = [
  ['are', 'race', 'clear', 'recall'],
  ['ear', 'rage', 'great', 'garnet'],
  ['tea', 'tale', 'fetal', 'falter'],
  ['ate', 'mate', 'steam', 'steamy'],
  ['eat', 'tale', 'table', 'battle'],
  ['are', 'bear', 'brace', 'breach'],
  ['ear', 'tear', 'great', 'gather'],
  ['tea', 'heat', 'bathe', 'bertha'],
  ['ate', 'team', 'tamed', 'dreamt'],
  ['eat', 'tape', 'taped', 'tapped'],
  ['are', 'care', 'brace', 'breach'],
  ['ear', 'tear', 'stare', 'arrest'],
  ['tea', 'tale', 'tesla', 'stella'],
  ['ate', 'seat', 'state', 'estate'],
  ['eat', 'seat', 'skate', 'staked'],
  ['are', 'earn', 'anger', 'german'],
  ['ear', 'bear', 'brave', 'beaver'],
  ['tea', 'neat', 'agent', 'magnet'],
  ['ate', 'tear', 'terra', 'rather'],
  ['eat', 'gate', 'great', 'target'],
  ['are', 'gear', 'eager', 'reggae'],
  ['ear', 'care', 'cream', 'camera'],
  ['tea', 'neat', 'meant', 'mental'],
  ['ate', 'rate', 'grate', 'target'],
  ['eat', 'seat', 'haste', 'chaste'],
  ['are', 'read', 'rated', 'traced'],
  ['ear', 'bare', 'brave', 'verbal'],
  ['tea', 'heat', 'teach', 'chaste'],
  ['ate', 'date', 'delta', 'talked'],
  ['eat', 'neat', 'meant', 'mental'],
  ['are', 'dear', 'adore', 'ordeal'],
  ['ear', 'real', 'laser', 'serial'],
  ['tea', 'seat', 'beast', 'basket'],
  ['ate', 'heat', 'cheat', 'chalet'],
  ['eat', 'heat', 'earth', 'rather'],
  ['are', 'rage', 'glare', 'gravel'],
  ['ear', 'race', 'cater', 'cartel'],
  ['tea', 'late', 'dealt', 'talked'],
  ['ate', 'east', 'stare', 'arrest'],
  ['eat', 'gate', 'agent', 'eating'],
  ['are', 'bear', 'saber', 'breast'],
  ['ear', 'vera', 'raven', 'ravine'],
  ['tea', 'rate', 'trace', 'create'],
  ['ate', 'rate', 'alert', 'travel'],
  ['eat', 'tale', 'later', 'learnt'],
  ['are', 'real', 'early', 'really'],
  ['ear', 'read', 'drake', 'darker'],
  ['tea', 'late', 'plate', 'planet'],
  ['ate', 'gate', 'agent', 'eating'],
  ['eat', 'heat', 'teach', 'chaste'],
  ['are', 'dare', 'padre', 'parked'],
  ['ear', 'gear', 'marge', 'mirage'],
  ['tea', 'east', 'stare', 'arrest'],
  ['ate', 'east', 'paste', 'staple'],
  ['eat', 'east', 'state', 'latest'],
  ['are', 'read', 'adore', 'adored'],
  ['ear', 'near', 'raven', 'tavern'],
  ['tea', 'seat', 'least', 'latest'],
  ['ate', 'late', 'fetal', 'falter'],
  ['eat', 'tear', 'earth', 'threat'],
  ['are', 'dear', 'dared', 'ladder'],
  ['ear', 'tear', 'water', 'watery'],
  ['tea', 'gate', 'grate', 'gather'],
  ['ate', 'gate', 'great', 'target'],
  ['eat', 'east', 'waste', 'sweaty'],
  ['are', 'dare', 'trade', 'traced'],
  ['ear', 'read', 'ready', 'dreary'],
  ['tea', 'rate', 'mater', 'stream'],
  ['ate', 'tear', 'eater', 'easter'],
  ['eat', 'meat', 'metal', 'mantle'],
  ['are', 'dare', 'grade', 'garden'],
  ['ear', 'dare', 'cedar', 'cradle'],
  ['tea', 'tear', 'earth', 'threat'],
  ['ate', 'east', 'asset', 'assert'],
  ['eat', 'rate', 'eater', 'repeat'],
  ['sea', 'sale', 'slate', 'castle'],
  ['net', 'tend', 'trend', 'tender'],
  ['end', 'need', 'ended', 'needed'],
  ['ace', 'race', 'racer', 'crater'],
  ['pal', 'slap', 'splat', 'postal'],
  ['ask', 'sake', 'steak', 'streak'],
  ['hit', 'thin', 'thine', 'ethnic'],
  ['lap', 'plan', 'plain', 'spinal'],
  ['rat', 'rate', 'trace', 'create'],
  ['day', 'lady', 'delay', 'played'],
  ['tag', 'gate', 'great', 'target'],
  ['ole', 'lose', 'close', 'closed'],
  ['hot', 'thou', 'tough', 'though'],
  ['sat', 'last', 'salty', 'lastly'],
  ['air', 'rain', 'brain', 'binary'],
  ['see', 'else', 'lease', 'asleep'],
  ['map', 'lamp', 'ample', 'sample'],
  ['and', 'sand', 'stand', 'strand'],
  ['art', 'star', 'darts', 'stared'],
  ['aye', 'year', 'ready', 'prayed'],
  ['men', 'mean', 'named', 'demand'],
  ['met', 'term', 'mater', 'stream'],
  ['red', 'ride', 'tried', 'credit'],
  ['one', 'bone', 'borne', 'bronze'],
  ['age', 'rage', 'agree', 'grease'],
  ['her', 'hear', 'share', 'search'],
  ['raw', 'warn', 'drawn', 'warden'],
  ['run', 'burn', 'burnt', 'turban'],
  ['bar', 'bare', 'zebra', 'brazen'],
  ['sat', 'stay', 'yeast', 'stayed'],
  ['con', 'once', 'recon', 'corner'],
  ['ace', 'race', 'recap', 'parcel'],
  ['men', 'amen', 'named', 'medina'],
  ['one', 'tone', 'noted', 'rodent'],
  ['nor', 'born', 'baron', 'carbon'],
  ['red', 'dear', 'raced', 'dancer'],
  ['hot', 'thou', 'shout', 'sought'],
  ['lay', 'lady', 'delay', 'played'],
  ['rat', 'brat', 'abort', 'barton'],
  ['art', 'cart', 'crate', 'create'],
  ['set', 'west', 'sweat', 'wasted'],
  ['led', 'lend', 'blend', 'blonde'],
  ['war', 'wear', 'swear', 'answer'],
  ['pal', 'pale', 'plane', 'alpine'],
  ['art', 'cart', 'cater', 'crater'],
  ['ole', 'mole', 'model', 'melody'],
  ['rat', 'rate', 'great', 'target'],
  ['the', 'heat', 'haste', 'hasten'],
  ['law', 'wall', 'allow', 'wallow'],
  ['age', 'gate', 'agent', 'eating'],
  ['car', 'scar', 'scare', 'scream'],
  ['lad', 'deal', 'blade', 'blamed'],
  ['sea', 'east', 'steal', 'castle'],
  ['not', 'note', 'tenor', 'rotten'],
  ['art', 'rate', 'alter', 'learnt'],
  ['ace', 'each', 'cache', 'chance'],
  ['rat', 'rate', 'later', 'travel'],
  ['fit', 'lift', 'filth', 'flight'],
  ['pat', 'past', 'paste', 'aspect'],
  ['art', 'tear', 'alter', 'taller'],
  ['net', 'sent', 'tense', 'senate'],
  ['one', 'once', 'ounce', 'bounce'],
  ['set', 'sent', 'scent', 'nicest'],
  ['own', 'down', 'drown', 'onward'],
  ['pat', 'part', 'tramp', 'armpit'],
  ['age', 'gear', 'eager', 'reggae'],
  ['nor', 'born', 'robin', 'boring'],
  ['ash', 'cash', 'chase', 'chased'],
  ['ken', 'neat', 'taken', 'tanker'],
  ['hut', 'hurt', 'truth', 'thrust'],
  ['out', 'tour', 'outer', 'troupe'],
  ['raw', 'warn', 'rowan', 'narrow'],
  ['rat', 'cart', 'chart', 'starch'],
  ['ray', 'pray', 'repay', 'prayer'],
  ['led', 'dale', 'pedal', 'played'],
  ['pal', 'pale', 'pearl', 'player'],
  ['pit', 'trip', 'strip', 'spirit'],
  ['mad', 'maid', 'admit', 'dammit'],
  ['age', 'gear', 'range', 'german'],
  ['inn', 'nine', 'linen', 'linden'],
  ['and', 'land', 'laden', 'handle'],
  ['bag', 'bang', 'began', 'banged'],
  ['out', 'thou', 'south', 'sought'],
  ['aye', 'year', 'yearn', 'nearby'],
  ['art', 'cart', 'react', 'traced'],
  ['eve', 'even', 'venue', 'avenue'],
  ['ace', 'care', 'reach', 'charge'],
  ['act', 'coat', 'costa', 'castor'],
  ['sea', 'seat', 'taste', 'statue'],
  ['red', 'dare', 'padre', 'parked'],
  ['bet', 'beat', 'table', 'battle'],
  ['sir', 'rise', 'risen', 'singer'],
  ['lie', 'lied', 'glide', 'girdle'],
  ['led', 'lied', 'ideal', 'nailed'],
  ['sea', 'same', 'steam', 'master'],
  ['may', 'many', 'mayan', 'cayman'],
  ['art', 'tear', 'alert', 'travel'],
  ['red', 'reed', 'greed', 'degree'],
  ['has', 'cash', 'chase', 'chased'],
  ['per', 'rope', 'power', 'powder'],
  ['kid', 'kind', 'dinky', 'kindly'],
  ['ace', 'cafe', 'decaf', 'facade'],
  ['hut', 'shut', 'south', 'sought'],
  ['sea', 'east', 'paste', 'staple'],
  ['toy', 'troy', 'story', 'shorty'],
  ['air', 'liar', 'pilar', 'spiral'],
  ['nut', 'unit', 'untie', 'minute'],
  ['led', 'dale', 'plead', 'paddle'],
  ['pat', 'trap', 'tramp', 'tamper'],
  ['net', 'rent', 'enter', 'entire'],
  ['tie', 'site', 'exist', 'sexist'],
  ['rid', 'raid', 'drain', 'daring'],
  ['ice', 'eric', 'price', 'prince'],
  ['lap', 'slap', 'splat', 'postal'],
  ['rat', 'star', 'trash', 'thrash'],
  ['bee', 'beep', 'bleep', 'pebble'],
  ['ran', 'rank', 'drank', 'darken'],
  ['sea', 'east', 'stake', 'casket'],
  ['aim', 'main', 'mania', 'animal'],
  ['old', 'cold', 'could', 'cloudy'],
  ['age', 'gear', 'graze', 'grazed'],
  ['elm', 'mole', 'melon', 'molten'],
  ['bat', 'beat', 'bathe', 'breath'],
  ['pal', 'palm', 'maple', 'sample'],
  ['art', 'tear', 'react', 'create'],
  ['lay', 'lady', 'daily', 'milady'],
  ['nor', 'iron', 'intro', 'ration'],
  ['ago', 'goat', 'gator', 'bogart'],
  ['hat', 'what', 'wrath', 'warmth'],
  ['lad', 'dale', 'medal', 'mailed'],
  ['ain', 'gain', 'grain', 'caring'],
  ['pot', 'port', 'troop', 'pronto'],
  ['sit', 'site', 'spite', 'priest'],
  ['ten', 'rent', 'tenor', 'throne'],
  ['car', 'race', 'racer', 'archer'],
  ['lot', 'lost', 'stole', 'stolen'],
  ['hat', 'heat', 'heart', 'father'],
  ['tie', 'tide', 'tired', 'editor'],
  ['ten', 'tune', 'unite', 'united'],
  ['rub', 'burn', 'burnt', 'burton'],
  ['cap', 'pace', 'peace', 'apiece'],
  ['sea', 'seat', 'slate', 'stella'],
  ['end', 'lend', 'laden', 'landed'],
  ['die', 'tied', 'tired', 'direct'],
  ['ace', 'care', 'trace', 'create'],
  ['car', 'race', 'trace', 'cartel'],
  ['sea', 'save', 'saved', 'advise'],
  ['end', 'tend', 'tuned', 'turned'],
  ['led', 'lead', 'medal', 'blamed'],
  ['day', 'yard', 'hardy', 'hardly'],
  ['tie', 'tire', 'tribe', 'timber'],
  ['far', 'fear', 'flare', 'raffle'],
  ['ace', 'care', 'raced', 'traced'],
  ['led', 'lead', 'ideal', 'detail'],
  ['rat', 'rate', 'after', 'father'],
  ['tie', 'time', 'timer', 'mister'],
  ['hat', 'that', 'theta', 'threat'],
  ['ray', 'army', 'mayor', 'armory'],
  ['led', 'dale', 'dealt', 'detail'],
  ['bow', 'bowl', 'below', 'blower'],
  ['art', 'tear', 'later', 'taller'],
  ['set', 'sent', 'stone', 'honest'],
  ['net', 'tune', 'tuned', 'turned'],
  ['led', 'dale', 'ideal', 'denial'],
  ['hot', 'host', 'those', 'hostel'],
  ['art', 'rate', 'rated', 'thread'],
  ['met', 'team', 'tamed', 'dreamt'],
  ['let', 'late', 'dealt', 'talked'],
  ['cut', 'cute', 'acute', 'faucet'],
  ['ram', 'army', 'mayor', 'armory'],
  ['art', 'star', 'stray', 'pastry'],
  ['not', 'tone', 'stone', 'stolen'],
  ['and', 'dean', 'named', 'demand'],
  ['end', 'tend', 'tuned', 'turned'],
  ['log', 'golf', 'glove', 'govern'],
  ['art', 'tear', 'after', 'faster'],
  ['sit', 'fist', 'shift', 'shifty'],
  ['bro', 'bore', 'broke', 'broken'],
  ['ice', 'nice', 'since', 'nicest'],
  ['hop', 'hope', 'phone', 'phoned'],
  ['net', 'nest', 'stone', 'soften'],
  ['sea', 'same', 'shame', 'mashed'],
  ['air', 'pair', 'paris', 'praise'],
  ['one', 'done', 'devon', 'vendor'],
  ['sit', 'site', 'heist', 'thesis'],
  ['led', 'deal', 'medal', 'calmed'],
  ['lap', 'slap', 'scalp', 'pascal'],
  ['and', 'dean', 'dance', 'dancer'],
  ['aid', 'laid', 'laird', 'lizard'],
  ['ace', 'case', 'cause', 'caused'],
  ['ran', 'rain', 'rainy', 'brainy'],
  ['sue', 'sure', 'usher', 'rushed'],
  ['and', 'dean', 'laden', 'landed'],
  ['sat', 'star', 'stark', 'streak'],
  ['red', 'dear', 'ready', 'prayed'],
  ['led', 'dale', 'delta', 'lasted'],
  ['new', 'wine', 'swine', 'sewing'],
  ['ken', 'knee', 'kneel', 'kennel'],
  ['air', 'raid', 'rapid', 'paired'],
  ['eve', 'ever', 'lever', 'clever'],
  ['raw', 'draw', 'drawn', 'warned'],
  ['bad', 'brad', 'rabid', 'bridal'],
  ['met', 'time', 'timed', 'midget'],
  ['car', 'race', 'cater', 'carpet'],
  ['red', 'dear', 'padre', 'spread'],
  ['rat', 'cart', 'track', 'racket'],
  ['eat', 'date', 'tamed', 'teamed'],
  ['art', 'rate', 'stare', 'master'],
  ['lab', 'able', 'blaze', 'blazer'],
  ['lap', 'pale', 'plate', 'planet'],
  ['met', 'them', 'theme', 'helmet'],
  ['led', 'deal', 'ideal', 'failed'],
  ['sea', 'case', 'scale', 'castle'],
  ['age', 'gear', 'agree', 'agreed'],
  ['tip', 'trip', 'print', 'sprint'],
  ['met', 'mate', 'metal', 'mental'],
  ['han', 'than', 'haunt', 'naught'],
  ['sea', 'easy', 'yeast', 'stayed'],
  ['sat', 'task', 'steak', 'basket'],
  ['raw', 'wear', 'weary', 'lawyer'],
  ['age', 'gear', 'grade', 'danger'],
  ['let', 'tale', 'latte', 'battle'],
  ['dig', 'ding', 'dying', 'drying'],
  ['out', 'tour', 'route', 'detour'],
  ['ace', 'race', 'cream', 'carmen'],
  ['the', 'beth', 'berth', 'bother'],
  ['bar', 'brad', 'brand', 'brandy'],
  ['old', 'bold', 'blood', 'bloody'],
  ['sea', 'east', 'waste', 'sweaty'],
  ['art', 'tear', 'eater', 'easter'],
  ['sat', 'star', 'darts', 'stared'],
  ['ace', 'pace', 'space', 'aspect'],
  ['red', 'dear', 'dared', 'ladder'],
  ['car', 'cart', 'crate', 'carpet'],
  ['sad', 'sand', 'stand', 'strand'],
  ['met', 'team', 'meant', 'mental'],
  ['pat', 'past', 'strap', 'pastry'],
  ['red', 'dear', 'rated', 'thread'],
  ['car', 'cart', 'crate', 'create'],
  ['bar', 'bare', 'rehab', 'breach'],
  ['tie', 'tide', 'tried', 'divert'],
  ['one', 'once', 'clone', 'cloned'],
  ['pet', 'poet', 'depot', 'posted'],
  ['red', 'read', 'padre', 'parade'],
  ['led', 'lied', 'liked', 'linked'],
  ['rat', 'rate', 'treat', 'matter'],
  ['ain', 'vain', 'naive', 'native'],
  ['not', 'into', 'pinto', 'potion'],
  ['pie', 'wipe', 'wiped', 'swiped'],
  ['tip', 'spit', 'strip', 'priest'],
  ['met', 'term', 'metre', 'remote'],
  ['art', 'part', 'party', 'partly'],
  ['eat', 'date', 'rated', 'thread'],
  ['aim', 'maid', 'aimed', 'maiden'],
  ['rid', 'ride', 'cried', 'priced'],
  ['pal', 'lamp', 'ample', 'sample'],
  ['let', 'late', 'alert', 'taller'],
  ['sat', 'seat', 'slate', 'stella'],
  ['con', 'corn', 'recon', 'reckon'],
  ['sea', 'east', 'stare', 'arrest'],
  ['lad', 'laid', 'laird', 'lizard'],
  ['his', 'fish', 'shift', 'shifty'],
  ['one', 'nose', 'shone', 'chosen'],
  ['red', 'ride', 'dried', 'riddle'],
  ['rat', 'part', 'tramp', 'armpit'],
  ['and', 'darn', 'drank', 'ranked'],
  ['aid', 'laid', 'daily', 'milady'],
  ['god', 'dong', 'doing', 'coding'],
  ['rid', 'ride', 'bride', 'bridge'],
  ['lad', 'dale', 'ideal', 'denial'],
  ['ago', 'goal', 'along', 'gallon'],
  ['sea', 'sake', 'shake', 'shaken'],
  ['tie', 'time', 'merit', 'permit'],
  ['hut', 'thou', 'shout', 'sought'],
  ['gus', 'sung', 'using', 'genius'],
  ['red', 'dare', 'ready', 'dreary'],
  ['sea', 'save', 'shave', 'shaved'],
  ['bar', 'bear', 'zebra', 'blazer'],
  ['let', 'late', 'latte', 'talent'],
  ['ran', 'earn', 'raven', 'ravine'],
  ['ale', 'lame', 'realm', 'morale'],
  ['man', 'many', 'mayan', 'cayman'],
  ['red', 'ride', 'pride', 'period'],
  ['gus', 'sung', 'stung', 'strung'],
  ['the', 'heat', 'cheat', 'chalet'],
  ['lad', 'dale', 'laden', 'nailed'],
  ['car', 'race', 'reach', 'search'],
  ['son', 'soon', 'noose', 'sooner'],
  ['sit', 'this', 'sight', 'slight'],
  ['set', 'test', 'state', 'estate'],
];
